import { render, staticRenderFns } from "./ques3.vue?vue&type=template&id=4462c49b"
import script from "./ques3.vue?vue&type=script&lang=js"
export * from "./ques3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports